// router
import Vue from "vue";

import routerPromise from "@/router/index";
console.log('导航栏3')
// vuex
import store from "./store";
// global css
import "@/styles/index.scss";
// svg icon
import "@/icons";
// auto flex
import AutoFlex from "@/components/AutoFlex";
Vue.component("auto-flex", AutoFlex);
// tabs
import ZeroTabs from "@/components/ZeroTabs";
Vue.component("z-tabs", ZeroTabs);
// button
import ZeroButton from "@/components/ZeroButton";
Vue.component("z-button", ZeroButton);
// tag
import ZeroTag from "@/components/ZeroTag";
Vue.component("z-tag", ZeroTag);
//FooterNav
import FooterNav from "@/components/FooterNav";
Vue.component("FooterNav", FooterNav);

import PortalComponent from "portal-component";
import "@/styles/portal-variables.scss";
Vue.use(PortalComponent);

import SwIcon from "sw-icon";
Vue.use(SwIcon);

import VueBus from 'vue-bus'
Vue.use(VueBus);

// VueAwesomeSwiper
// import VueAwesomeSwiper from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
// Vue.use(VueAwesomeSwiper);

// 无缝滚动
// import SeamlessScroll from "vue-seamless-scroll";
// Vue.use(SeamlessScroll);

// 全局设置过滤器
import * as filters from "@/filters";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
import App from "./App.vue";
import qs from "query-string";
let url = location.href;
let params = qs.parseUrl(url).query;

if (params && params.componentConfig) {
  let stringCC = decodeURIComponent(params.componentConfig);
  try {
    let cc = JSON.parse(stringCC);
    store.commit("SET_COMPONENT_CONIFG", cc);
  } catch (e) {
  }
}else{
  store.commit("SET_COMPONENT_CONIFG", {});
}
import KeepRatio from "vue-keep-ratio";
Vue.use(KeepRatio);
routerPromise.then((router) => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount(
    "#app");
})

export {}
